import api from '../store/apiClient';

export const storeSettingsService = {
  getSettings: async () => {
    const { data } = await api.get('/store/settings', {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    });
    return data?.data ?? data;
  },
};
